<div id="sales-box" class="p-3 mb-5">
  <h3>ABMP CE Pricing</h3>
  <div id="blue-bar"></div>

  <div id="cards" class="container my-3">
    <div class="row">
      <div class="col-0 col-lg-1"></div>
      <div class="col col-md-3 col-lg-2 p-2 card short">
        <h4>One</h4>
        <h5>$30</h5>
        <p>1 course with CE</p>
        <a routerLink="/courses" title="Course catalog">Select</a>
      </div>
      <div class="col-0 col-md-1"></div>

      <div class="col col-md-4 col-lg-4 p-2 card short">
        <h4>Some</h4>
        <div class="d-flex">
          <div class="w-50">
            <h5>$99</h5>
            <p>5 courses with CE</p>
          </div>
          <div class="w-50">
            <h5>$149</h5>
            <p>10 courses with CE</p>
          </div>
        </div>
        <a routerLink="/pricing" title="Pricing page">Select</a>
      </div>

      <div class="col-0 col-md-1"></div>
      <div class="col col-md-3 col-lg-2 p-2 card">
        <h4 class="border-0">All</h4>
        <span class="highlight">Best Value</span>
        <h5>$199</h5>
        <p>ABMP membership includes 200+<br />courses with CE</p>
        <a routerLink="/pricing" title="Pricing page">Select</a>
      </div>
      <div class="col-0 col-xl-1"></div>
    </div>
  </div>
</div>